var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClimateAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / climate_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.2379665%",
    y1: "0%",
    x2: "50%",
    y2: "126.2341%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.307555%",
    y1: "0%",
    x2: "53.131006%",
    y2: "86.6286058%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,0 C19.1944204,-8.62351033e-16 23,3.80557963 23,8.5 L23,17 L30,17 L30,20.5 L23,20.5 L23,31.25 L30,31.25 L30,34.75 L23,34.75 L23,45.5 L30,45.5 L30,49 L23,49 L23.0007721,55.7519264 C26.6357453,58.3867255 29,62.6672621 29,67.5 C29,75.5081289 22.5081289,82 14.5,82 C6.49187113,82 0,75.5081289 0,67.5 C0,62.6668156 2.3646916,58.3859346 6.00023543,55.7511962 L6,8.5 C6,3.80557963 9.80557963,8.62351033e-16 14.5,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-climate_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Climate",
    transform: "translate(30.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,34 L18.0010922,58.6659444 C21.5151348,60.0597997 24,63.4897142 24,67.5 C24,72.7467051 19.7467051,77 14.5,77 C9.25329488,77 5,72.7467051 5,67.5 C5,63.4893341 7.48533626,60.0591495 10.999907,58.6655481 L11,34 L18,34 Z",
    id: "Temp---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Temp---Border"
  }, /*#__PURE__*/React.createElement("use", {
    strokeOpacity: 0.980933129,
    stroke: "#FCFCFC",
    strokeWidth: 4,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-2)",
    strokeWidth: 3,
    d: "M14.5,1.5 C16.4329966,1.5 18.1829966,2.28350169 19.4497475,3.55025253 C20.7164983,4.81700338 21.5,6.56700338 21.5,8.5 L21.5,8.5 L21.5,18.5 L28.5,18.5 L28.5,19 L21.5,19 L21.5,32.75 L28.5,32.75 L28.5,33.25 L21.5,33.25 L21.5,47 L28.5,47 L28.5,47.5 L21.4998285,47.5 L21.5008626,56.5439676 C25.1083519,58.8545065 27.5,62.8978259 27.5,67.5 C27.5,71.0898509 26.0449254,74.3398509 23.6923882,76.6923882 C21.3398509,79.0449254 18.0898509,80.5 14.5,80.5 C10.9101491,80.5 7.66014913,79.0449254 5.30761184,76.6923882 C2.95507456,74.3398509 1.5,71.0898509 1.5,67.5 C1.5,62.8973573 3.89213512,58.8536832 7.50023937,56.5432618 L7.50023937,56.5432618 L7.5,8.5 C7.5,6.56700338 8.28350169,4.81700338 9.55025253,3.55025253 C10.8170034,2.28350169 12.5670034,1.5 14.5,1.5 Z",
    strokeLinejoin: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateAppTile);
export default __webpack_public_path__ + "static/media/climate_app_tile.d0d88a5cbb36c124f2b003490d5a75bd.svg";
export { ForwardRef as ReactComponent };